import { render, staticRenderFns } from "./ParlayTab.vue?vue&type=template&id=571888be&"
import script from "./ParlayTab.vue?vue&type=script&lang=js&"
export * from "./ParlayTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports